import './defaultNoViewContentType2.less'

import { Button, Typography } from '@lightbeamai/design-system'

import React from 'react'

interface IProps {
  heading?: string
  body?: string
  buttonLabel?: string
  handleAction?: () => void
  SvgIcon: React.FC<React.SVGProps<SVGSVGElement>>
}

const DefaultNoViewContentType2 = (props: IProps) => {
  const { body, buttonLabel, handleAction, SvgIcon, heading } = props

  return (
    <div className="no-consents-region-default-container">
      <div>
        <SvgIcon />
      </div>
      {heading && (
        <Typography variant={'baseMinus2'} type={'strong'}>
          {heading}
        </Typography>
      )}
      {body && (
        <Typography variant="baseMinus4" className="message">
          {body}
        </Typography>
      )}
      {buttonLabel && (
        <Button variant="primary" size={24} className="config-button" onClick={handleAction}>
          {buttonLabel}
        </Button>
      )}
    </div>
  )
}

export default DefaultNoViewContentType2
